import { Size } from '@ff-os/shared-utils/types/Size';
import { urls } from '@ff-os/shared-utils/urls';
import { Paintable } from 'ff-canvas';
import { magic_effects } from './magic_effects';
import { standard_effects } from './standard_effects';
import { StrokeSettings } from './StrokeSettings';

export const toPatternPaintable = (
    photoId: string,
    size: Size,
    tileSize: number,
    border: StrokeSettings
): Paintable => {

    const allEffects = [...magic_effects, ...standard_effects];
    const frameEffect = allEffects.find(effect => effect.id === border.frameId);

    if (!frameEffect) {
        throw new Error(`Pattern not found: ${border.frameId}`);
    }

    const url = urls.publicAssetUrl(frameEffect.assetId);
    const maxSide = Math.max(size.width, size.height);

    return {
        id: `pattern-${photoId}`,
        type: 'pattern',
        url: url,

        x: -maxSide / 2,
        y: -maxSide / 2,
        width: maxSide,
        height: maxSide,
        imageWidth: tileSize,
        imageHeight: tileSize,

        alpha: 1,
        angle: 0,
        round: false,
        scaleX: 1,
        scaleY: 1,

        flipX: false,
        flipY: false,

        shadow: false,
        shadowBlur: 0,
        shadowColor: '#000000',
        shadowOffsetX: 0,
        shadowOffsetY: 0,

        stroke: false,
        strokeSize: 0,
        strokeStyle: '#ffffff',

        zIndex: 0,

        custom: {
            watch: [],
            values: {
                isMagic: frameEffect.isMagic,
                frameId: border.frameId
            }
        }
    };
};